/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

export const accountState = {
    current_guid: undefined,
    current: undefined,
    roles: []
};
